import { loadConfig } from "@/services/config";

export const configModule = {
  namespaced: true,
  state: {
    client: "-",
    locale: "es",
    menu: {
      1: {
        orders: {
          visible: true,
          order: true,
        },
        administration: {
          visible: false,
          user: false,
          roles: false,
          permissions: false,
          clients: false,
        },
      },
      2: {
        orders: {
          visible: true,
          order: true,
        },
        administration: {
          visible: true,
          user: false,
          roles: false,
          permissions: false,
          clients: true,
          jobs: true,
        },
      },
      3: {
        orders: {
          visible: true,
          order: true,
        },
        administration: {
          visible: true,
          user: true,
          roles: true,
          permissions: true,
          clients: true,
          jobs: true,
        },
      },
    },
    visibleFields: [
      "start_date",
      "client",
      "order",
      "expedition",
      "operatorName",
      "recorderId",
    ],
    visibleFieldsDetail: [
      "start_date",
      "end_date",
      "client",
      "order",
      "expedition",
      "operatorName",
      "recorderId",
    ],
    visibleFieldsOrdersDataVisor: [],
    aiEventsEnabled: false,
    names: {
      start_date: "Fecha inicio",
      end_date: "Fecha fin",
      recorderId: "Carretilla",
      expedition: "Expedición",
      operatorName: "Operario",
      truck_plate: "Matrícula",
      trailer_plate: "Remolque",
      container: "Contenedor",
      container_seal: "Precinto",
      packingList: "Albarán",
      client: "Cliente",
      order: "Orden",
      date: "Fecha",
      date_start: "Rango fechas",
      date_finish: "Fin",
      order_line: "Linea de Pedido",
      orders: "Videos",
      integrity: "Integridad",
    },
    columnTypes: {
      start_date: "Date",
      end_date: "Date",
      recorderId: "String",
      expedition: "String",
      operatorName: "String",
      truck_plate: "String",
      trailer_plate: "String",
      container: "String",
      container_seal: "String",
      packingList: "String",
      client: "String",
      order: "String",
      integrity: "String",
    },
    mainAttributes: [],
    additionalAttributes: [],
    logoUrl: "",
  },
  mutations: {
    setClient(state, payload) {
      state.client = payload;
    },
    setLocale(state, payload) {
      state.locale = payload;
    },
    setMenu(state, payload) {
      state.menu = payload;
    },
    setVisibleFields(state, payload) {
      state.visibleFields = payload;
    },
    setVisibleFieldsDetail(state, payload) {
      state.visibleFieldsDetail = payload;
    },
    setVisibleFieldsOrdersDataVisor(state, payload) {
      state.visibleFieldsOrdersDataVisor = payload;
    },
    setAiEventsEnabled(state, payload) {
      state.aiEventsEnabled = payload;
    },
    setNames(state, payload) {
      state.names = payload;
    },
    setColumnTypes(state, payload) {
      state.columnTypes = payload;
    },
    setMainAttributes(state, payload) {
      state.mainAttributes = payload;
    },
    setAdditionalAttributes(state, payload) {
      state.additionalAttributes = payload;
    },
    setLogoUrl(state, payload) {
      state.logoUrl = payload;
    },
  },
  actions: {
    async loadConfig({ commit }) {
      const data = await loadConfig();
      if (data) {
        const {
          client,
          locale,
          menu,
          visibleFields,
          visibleFieldsDetail,
          visibleFieldsOrdersDataVisor,
          names,
          columnTypes,
          aiEventsEnabled,
        } = data;

        commit("setClient", client);
        commit("setLocale", locale);
        commit("setMenu", menu);
        commit("setVisibleFields", visibleFields);
        commit("setVisibleFieldsDetail", visibleFieldsDetail);
        commit("setVisibleFieldsOrdersDataVisor", visibleFieldsOrdersDataVisor);
        commit("setNames", names);
        commit("setColumnTypes", columnTypes);
        commit("setAiEventsEnabled", !!aiEventsEnabled);
        commit("setMainAttributes", data.mainAttributes);
        commit("setAdditionalAttributes", data.additionalAttributes);
        commit("setLogoUrl", data.logo);
      }
    },
  },
  getters: {},
};
